module.exports = __webpack_public_path__ + "img/pservicio.54c0ea14.svg";